import { useFeiertagskonto } from '@/domain/mitarbeiter/features/feiertagskonto/hooks';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Button,
  Card,
  CardContent,
  EmptyState,
  Heading,
  Title,
} from '@e2n/ui/v2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { faCalendarCirclePlus } from '@fortawesome/pro-regular-svg-icons';
import { faTrash } from '@fortawesome/pro-regular-svg-icons';
import dayjs from 'dayjs';
import { useYearPickerContext } from '@/domain/mitarbeiter/features/feiertagskonto/shared/YearPickerContext';
import {
  BemerkungDrawer,
  KontausgleichArtBadge,
} from '@/domain/mitarbeiter/features/feiertagskonto/features/kontoausgleich/components';
import { useStandortContext } from '@/features/standortContext/StandortContext';

export function KontoausgleichMobile() {
  const { t } = useTranslation();
  const { id } = useParams();
  const { zeitraum, year } = useYearPickerContext();
  const {
    currentStandort: { id: standortId },
  } = useStandortContext();
  const {
    feiertagskonto: { kontoausgleiche: kontoausgleich },
  } = useFeiertagskonto({
    mitarbeiterId: id,
    zeitraum: zeitraum,
    standortId: standortId,
  });
  return (
    <div className="flex flex-col gap-4">
      <Heading size="md" weight="bold">
        {t('domain.mitarbeiter.feiertagskonto.kontoausgleich.titel')}
      </Heading>
      {kontoausgleich.length > 1 ? (
        <Card>
          <CardContent>
            {kontoausgleich.map((item, i) => (
              <Accordion key={i} className="w-119" type="multiple">
                <AccordionItem
                  value={t(
                    'domain.mitarbeiter.feiertagskonto.kontoausgleich.datum',
                  )}>
                  <AccordionTrigger>
                    {dayjs(item.datum).format('dd., DD.MM')}
                  </AccordionTrigger>
                  <AccordionContent>
                    <div className="flex flex-col gap-4">
                      <div className="flex gap-4">
                        <div className="flex flex-col p-0.5">
                          <Title className="text-labels-secondary text-xs font-semibold">
                            {t(
                              'domain.mitarbeiter.feiertagskonto.kontoausgleich.art',
                            )}
                          </Title>
                          <KontausgleichArtBadge art={item.art} />
                        </div>
                        <div>
                          <Title className="text-labels-secondary text-xs font-semibold p-0.5">
                            {t(
                              'domain.mitarbeiter.feiertagskonto.kontoausgleich.tage',
                            )}
                          </Title>
                          <div>{item.tage.toLocaleString('de-DE')}</div>
                        </div>
                      </div>
                      <div className="flex gap-2">
                        <BemerkungDrawer bemerkung={item.bemerkung} />
                        <Button
                          variant="secondary-red"
                          iconOnly
                          size="small"
                          aria-label={t('actions.löschen')}>
                          <FontAwesomeIcon icon={faTrash} />
                        </Button>
                      </div>
                    </div>
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            ))}
          </CardContent>
        </Card>
      ) : (
        <Card>
          <CardContent className="p-4">
            <EmptyState
              title={t(
                'domain.mitarbeiter.feiertagskonto.kontoausgleich.noDataTitle',
              )}
              description={t(
                'domain.mitarbeiter.feiertagskonto.kontoausgleich.noDataDescription',
                { year: dayjs(year).year() },
              )}
              icon={
                <FontAwesomeIcon
                  icon={faCalendarCirclePlus}
                  className="text-neutrals-700"
                />
              }></EmptyState>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
